import React from "react";
import LoadingSpinner from "./LoadingSpinner.jsx";

const LoadingScreen = () => {
  return (
    <div className="request-account-form__loading-screen">
      <LoadingSpinner />
      Loading...
    </div>
  );
};
export default LoadingScreen;
